<template>
	<div
		class="plus-info-inner-wrapper bg-white border-1 border position-relative my-0 my-sm-5">
		<div
			class="d-flex justify-content-between title-container py-3">
			<slot name="title"></slot>
            <CloseButton @click="handleClick"/>
		</div>
		<slot name="content"></slot>

	</div>
</template>

<script setup lang="ts">
import {defineEmits} from "vue"

// Components
import CloseButton from "@/vue/common/clsBtnV2.vue"

const emit = defineEmits<{
  (event: 'close'): void
}>(); 

const handleClick = (): void => {
    emit("close")
}


</script>

<style scoped>
.title-container {
	border-bottom: 2px solid var(--grey-100);
}
</style>
